import { render, staticRenderFns } from "./role1.vue?vue&type=template&id=10c7073e&scoped=true&"
import script from "./role1.vue?vue&type=script&lang=js&"
export * from "./role1.vue?vue&type=script&lang=js&"
import style0 from "./role1.vue?vue&type=style&index=0&id=10c7073e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c7073e",
  null
  
)

export default component.exports